// extracted by mini-css-extract-plugin
var _1 = "NotificationInline-moduleaction__dmZmJ";
var _2 = "NotificationInline-moduleactionsBox__jZGJ3";
var _3 = "NotificationInline-modulecolorLayer__Syw89";
var _4 = "NotificationInline-modulecontent__ui4rJ";
var _5 = "NotificationInline-moduleerror__Y5ief";
var _6 = "NotificationInline-moduleicon__MsBR8 IconNG-moduleiconContainer__SxWZ0";
var _7 = "NotificationInline-moduleinfo__pLPfI";
var _8 = "NotificationInline-modulelink__qUi1a";
var _9 = "NotificationInline-modulenotification__JUyv2";
var _a = "NotificationInline-modulesuccess__WOFXy";
var _b = "NotificationInline-moduletext__vW_V4 ClampingText-moduleclampingText__ANX4H";
var _c = "NotificationInline-modulewarning__NsROQ";
export { _1 as "action", _2 as "actionsBox", _3 as "colorLayer", _4 as "content", _5 as "error", _6 as "icon", _7 as "info", _8 as "link", _9 as "notification", _a as "success", _b as "text", _c as "warning" }
